import Login from "./screens/Login";
import VueRouter from "vue-router";
import Vue from 'vue'
import Home from "./screens/Home";
import Dashboard from "./screens/Dashboard";
import Taxi from "./screens/Taxi";
import Bus from "./screens/Bus";
import Travel from "./screens/Travel";
import AddTaxiDriver from "./components/taxi/AddTaxiDriver";
import Requests from "./components/taxi/Requests";
import AddBusStation from "./components/bus/AddBusStation";
import AddTravelCompany from './components/travel/AddCompany'
import AddBase from "./components/AddBase";
import Profile from "./screens/Profile";
import AddCity from "./components/AddCity";
import AddOffer from "./components/travel/AddOffer";
import Feedback from './screens/Feedback'

Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/Login',
            name: 'Login',
            component: Login,
        },
        {
            path: '/',
            name: 'FirstScreen',
            component: Login,
        },
        {
            path: '/Home',
            name: 'Home',
            component: Home,
            redirect: '/Home',
            children: [{
                path: '/Dashboard',
                name: 'Dashboard',
                component: Dashboard
            },
                {
                    path: '/Taxi',
                    name: 'Taxi',
                    component: Taxi
                },
                {
                    path: '/Bus',
                    name: 'Bus',
                    component: Bus,
                },
                {
                    path: '/add-bus-station',
                    name: 'Add Bus Station',
                    component: AddBusStation

                },
                {
                    path: '/Travel',
                    name: 'Travel',
                    component: Travel
                },
                {
                    path: '/add-company',
                    name: 'Add Travel Company',
                    component: AddTravelCompany
                },
                {
                    path: '/add-offer',
                    name: 'Add Travel Offer',
                    component: AddOffer
                },
                {
                    path: '/add-taxi-driver',
                    name: 'AddTaxiDriver',
                    component: AddTaxiDriver
                },
                {
                    path: '/requests',
                    name: 'Requests',
                    component: Requests
                },
                {
                    path: '/add-base',
                    name: 'Add Base',
                    component: AddBase
                },
                {
                    path: '/profile',
                    name: 'Profile',
                    component: Profile
                },
                {
                    path: '/add-city',
                    name: 'Add city',
                    component: AddCity
                },
                {
                    path: '/feedback',
                    name: 'Feedback',
                    component: Feedback
                },
            ]
        }
    ]
});

export default router
